export const matchViewMixin = {
  data() {
    return {
      matchFormLabel: {
        branchDesc: 'Branch',
        transactionType: 'Transaction Type',
        documentNo: 'Document No.',
        transactionDate: 'Transaction Date',
        accountingMonth: 'Accounting Month',
        accountingYear: 'Accounting Year',
        accountNoDesc: 'Account No.',
        fundDesc: 'Fund',
        suffixDesc: 'Suffix',
        gstIO: 'GST IO',
        gstStat: 'GST Status',
        gstRate: 'GST Rate',
        netAmtCurr: 'Net Amount Currency',
        netAmt: 'Net Amount',
        netAmtLoc: 'Net Amount Local',
        balOS: 'Balance Oustanding',
        balOSLoc: 'Balance Oustanding Local',
        matchOn: 'Match On',
        matchedRecTransDate: 'Matched Records Transaction Date',
        totalMatchAmountCurr: 'Currency',
        totalMatchAmount: 'Total Match Amount',
        totalMatchAmountLocalCurr: 'Currency',
        totalMatchAmountLocal: 'Total Match Amount Local',
        baseMatchAmountCurr: 'Currency',
        baseMatchAmount: 'Base Match Amount',
        baseMatchAmountLocalCurr: 'Currency',
        baseMatchAmountLocal: 'Base Match Amount Local',
        balanceOutStandingCurr: 'Currency',
        balanceOutStanding: 'Balance OutStanding',
        balanceOutStandingLocal: 'Balance OutStanding Local'
      },
      matchForm: {
        actionName: null,
        branch: null,
        transactionType: null,
        documentNo: null,
        transactionDate: null,
        accountingMonth: null,
        accountingYear: null,
        accountNo: null,
        fund: null,
        suffix: null,
        gstIO: null,
        gstStat: null,
        gstRate: null,
        netAmtCurr: null,
        netAmt: null,
        netAmtLocAE: false,
        netAmtLoc: null,
        balOS: '0.00',
        balOSLoc: '0.00',
        matchOn: null,
        matchedRecTransDate: new Date(),
        totalMatchAmountCurr: null,
        totalMatchAmount: '0.00',
        totalMatchAmountLocalCurr: null,
        totalMatchAmountLocal: '0.00',
        baseMatchAmountCurr: null,
        baseMatchAmount: '0.00',
        baseMatchAmountLocalCurr: null,
        baseMatchAmountLocal: '0.00',
        balanceOutStandingCurr: null,
        balanceOutStanding: '0.00',
        balanceOutStandingLocal: '0.00',
        matchDetItems: [],
        matchTransMinDate: null,
        matchTransMaxDate: null,
        action: null,
        branchDesc: null,
        accountNoDesc: null,
        fundDesc: null,
        suffixDesc: null,
        isMchUpld: false,
        fileName: null,
        gstStatDesc: null,
        transactionTypeDesc: null,
        gstIODesc: null
      },
      matchOn: [
        { label: 'Net', value: 'N' },
        { label: 'Gross', value: 'G' }
      ]
    }
  }
}
